import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";

let currentPage: PageInstanceSummary | null = null;

export const currentPageContext = {
    getCurrentPage() {
        return currentPage;
    },
    setPage(page: PageInstanceSummary) {
        currentPage = page;
    },
};
